import Vue from "vue";

export const DialogJobEventBus = new Vue();
